<template>
    <v-autocomplete
        v-model="autocomplete_model"
        :items="autocomplete_entries"
        :loading="autocomplete_isLoading"
        :search-input.sync="autocomplete_search"
        color="info"
        hide-no-data
        item-text="username"
        item-value="id"
        label="Player"
        class="regular-field remove-alignment-clear-icon"
        dense
        hide-details
        clearable
        :return-object="true"
        :error-messages="formerror.player_id"
    ></v-autocomplete>
</template>

<script>
    export default {

        props: [
            'filtertype',
        ],

        data(){
            return{
                autocomplete_entries: [],
                autocomplete_isLoading: false,
                autocomplete_model: [],
                autocomplete_search: '',
                formerror: {},
            };
        },
        methods:{
            
        },
        computed: {
            
        },
        watch: {
            // autocomplete_model(val, oldval) {
                // this.form.employee_id = val.id;
                // console.log(val);
                // return val.id;
            // },
            // formerror(){
            //     this.formerror.player_id = this.formerror.player_id;
            // },
            autocomplete_search (val) {
                let searchtype = null;
                var search = this.autocomplete_search;
                // if(this.filtertype == 'addbet'){
                //     search = this.autocomplete_search + '|addbet';
                // }
                if(this.filtertype){
                    searchtype = this.filtertype;
                }

                this.autocomplete_isLoading = true;
                this.$axios.post( this.$_CONFIG.api('API_SEARCH_PLAYER'), {player: search, searchtype: searchtype} )
                // axios.post('api/searchleaveemployee', {search: this.autocomplete_search})
                .then(res => {
                    this.count = 0;
                    this.autocomplete_entries = res.data;
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.autocomplete_isLoading = false))
            },
        },
        created(){
            
        },
        mounted() {
            
        }
    }
</script>
